import { useCallback, useEffect, useState } from "react"
import {
    AlertType, Bandeira, classBorderLabelDark, classBt, classbtAzul, classbtCinzaClaro, classbtColunasAzul, classbtColunasVermelho, classBtSemDuration, classbtVerde,
    classbtVermelho, classDivBackground, classDivBody, classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, Clientes,
    DadosBorderoLanctoCartao, LanctoCartao, LanctoCartaoaAttributes, Usuarios
} from "../../Utils/Types"
import { AiOutlineClear } from "react-icons/ai"
import { IoAddCircleSharp, IoCreate, IoSearch } from "react-icons/io5"
import { Link } from "react-router-dom"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { Template } from "../../Components/Template/template"
import { SearchBox } from "../../Components/SearchBox/SearchBox"
import { LanctoCartaoService } from "./LanctoCartaoService"
import { GridLanctoCartao } from "../../Components/GridProducts/GridLanctoCartao"
import { Funcoes } from "../../Utils/Funcoes"
import { ModalLiqLancamentoCartao } from "../../Components/Modal/modal-liq-lanc-cartao"
import { ModalEstLancamentoCartao } from "../../Components/Modal/modal-estornar-lanc-cartao"
import { GridLanctoCartaoEstorno } from "../../Components/GridProducts/GridLanctoCartaoEstorno"
import moment from "moment"
import { FaTrash } from "react-icons/fa"
import { Tooltip } from 'react-tooltip'

export const LancamentoCartaoPage = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    let dateF = moment()
        .utcOffset('-03:00')
        .add(31, 'days')
        .format('YYYY-MM-DD')

    // ---------- ATRIBUTOS FEEDBACK -----------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS FILTRO --------------------
    const [datai, setDatai] = useState(dateI)
    const [dataf, setDataf] = useState(dateF)
    const [tipo, setTipo] = useState("dt_vencimento")
    const [status, setStatus] = useState("A")

    const [idBandeira, setIdBandeira] = useState(0)
    const [bandeiraList, setBandeiraList] = useState<Bandeira[]>([])

    const [idVendedor, setIdVendedor] = useState(0)
    const [vendedorList, setVendedorList] = useState<Usuarios[]>([])

    const [idCliente, setIdCliente] = useState(0)
    const [clienteList, setClienteList] = useState<Clientes[]>([])

    const [bordero, setBordero] = useState("")

    const [idSelect, setIdSelect] = useState(false) // essa variavel é pra controlar a liquidação permitindo somente liquidar multiplas duplicatas do mesmo cliente


    // ---------- ATRIBUTOS GRID ---------------------  
    const [lanctoCartao, setLanctoCartao] = useState<LanctoCartao[]>([])
    const [lanctoCartaoEstorno, setLanctoCartaoEstorno] = useState<DadosBorderoLanctoCartao[]>([])
    const [attributes, setAttributes] = useState<LanctoCartaoaAttributes>()
    const [qtdLanctoCartao, setQtdLanctoCartao] = useState(0)
    const [totLanctoCartao, setTotLanctoCartao] = useState(0)
    const [totSelecionado, setTotSelecionado] = useState(0)
    const [qtdLanctoCartaoSelecionado, setQtdLanctoCartaoSelecionado] = useState(0)
    const [lanctoCartaoSelectedList, setLanctoCartaoSelectedList] = useState<number[]>([])
    const [borderoSelectedList, setBorderoSelectedList] = useState<number[]>([])
    const [selectDupAll, setSelectDupAll] = useState(false)

    // ------------- MODAL ---------------------------
    const [modalLiqLanctoCartaoVisible, setModalLiqLanctoCartaoVisible] = useState(false)
    const [modalCancelLiqVisible, setModalEstornoLanctoCartaoVisible] = useState(false)

    // ---------- ATRIBUTOS SEARCHBOX ----------------------------------
    const [visibleSearchBoxBandeira, setVisibleSearchBoxBandeira] = useState<boolean>(false)
    const [visibleSearchBoxVendedor, setVisibleSearchBoxVendedor] = useState<boolean>(false)
    const [visibleSearchBoxCliente, setVisibleSearchBoxCliente] = useState<boolean>(false)


    // ---------- ATRIBUTOS TUTORIAL ----------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)

    //------------------------------------------------------------------------------------------ REQUISIÇÃO API, ATALHOS E USEEFFECT ---------------------------------------------------------------------//
    const GetAttributes = async () => {

        setLoading(true)

        try {

            const cartao = await LanctoCartaoService.GetAttributes()
            setAttributes(cartao.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar as informações`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }
    }, [])

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroLanctoCartao") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !visibleSearchBoxBandeira && !visibleSearchBoxCliente && !visibleSearchBoxVendedor && !modalCancelLiqVisible && !modalLiqLanctoCartaoVisible && !loading && menuFiltro.classList.contains("max-h-[1000px]")) {
            await handleFilterClick()
        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleTabPress)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleTabPress)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }
    }, [datai, dataf, status, idBandeira, idCliente, idVendedor, bordero, visibleSearchBoxBandeira, visibleSearchBoxCliente, visibleSearchBoxVendedor, modalCancelLiqVisible, modalLiqLanctoCartaoVisible, loading])

    useEffect(() => {
        GetAttributes()
    }, [])

    useEffect(() => {
        setLanctoCartao([])
        setLanctoCartaoEstorno([])
        setBorderoSelectedList([])
        setLanctoCartaoSelectedList([])
        setTotSelecionado(0)
        setSelectDupAll(false)
        setQtdLanctoCartao(0)
        setTotLanctoCartao(0)
        setQtdLanctoCartaoSelecionado(0)
        setBordero("")

        if (status === "A") {
            setTipo("dt_vencimento")
        } else {
            setTipo("dt_baixa")
        }

    }, [status])

    const handleCloseMessage = () => {
        setVisible(false)
    }

    const searchBoxFocus = () => {
        setVisibleSearchBoxBandeira(false)
        setVisibleSearchBoxVendedor(false)
        setVisibleSearchBoxCliente(false)
    }

    //--------------------------------------------------------------------------------------------- FILTROS ------------------------------------------------------------------------------------------//
    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)

        setLanctoCartao([])
        setLanctoCartaoEstorno([])
        setBorderoSelectedList([])
        setLanctoCartaoSelectedList([])
        setTotSelecionado(0)
        setSelectDupAll(false)
        setQtdLanctoCartao(0)
        setTotLanctoCartao(0)
        setQtdLanctoCartaoSelecionado(0)

        searchBoxFocus()

        try {

            if (status === 'A') {

                const relatorio = {
                    dt_ini: datai,
                    dt_fim: dataf,
                    tipo: tipo,
                    status: status,
                    id_bandeira: idBandeira,
                    id_vendedor: idVendedor,
                    id_cliente: idCliente,
                }

                const cartao = await LanctoCartaoService.Filter(relatorio)

                if (cartao.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(cartao.msg || "")

                } else {

                    setLanctoCartao(cartao.data.lanctoCartao)
                    setQtdLanctoCartao(cartao.data.qtd)
                    setTotLanctoCartao(cartao.data.total)

                    if (idCliente > 0) {
                        setIdSelect(true)
                    } else {
                        setIdSelect(false)
                    }
                }

            } else {

                const relatorio = {
                    dt_ini: datai,
                    dt_fim: dataf,
                    tipo: tipo,
                    status: status,
                    id_bandeira: idBandeira,
                    id_vendedor: idVendedor,
                    id_cliente: idCliente,
                    bordero: bordero
                }

                const cartao = await LanctoCartaoService.FilterBordero(relatorio)

                if (cartao.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(cartao.msg || "")

                } else {

                    setLanctoCartaoEstorno(cartao.data.lanctoCartao)
                    setQtdLanctoCartao(cartao.data.qtd)
                    setTotLanctoCartao(cartao.data.total)

                }
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar os lançamentos e cartão`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 1500)
        }
    }

    const filterDados = useCallback(async () => {

        setVisible(false)
        setLanctoCartao([])
        setLanctoCartaoEstorno([])
        setBorderoSelectedList([])
        setLanctoCartaoSelectedList([])
        setTotSelecionado(0)
        setSelectDupAll(false)
        setQtdLanctoCartao(0)
        setTotLanctoCartao(0)
        setQtdLanctoCartaoSelecionado(0)

        try {

            if (status === 'A') {

                const relatorio = {
                    dt_ini: datai,
                    dt_fim: dataf,
                    tipo: tipo,
                    status: status,
                    id_bandeira: idBandeira,
                    id_vendedor: idVendedor,
                    id_cliente: idCliente,
                }

                const cartao = await LanctoCartaoService.Filter(relatorio)

                if (cartao.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(cartao.msg || "")
                    return false

                } else {

                    setLanctoCartao(cartao.data.lanctoCartao)
                    setQtdLanctoCartao(cartao.data.qtd)
                    setTotLanctoCartao(cartao.data.total)
                    return true
                }

            } else {

                const relatorio = {
                    dt_ini: datai,
                    dt_fim: dataf,
                    tipo: tipo,
                    status: status,
                    id_bandeira: idBandeira,
                    id_vendedor: idVendedor,
                    id_cliente: idCliente,
                    bordero: bordero
                }

                const cartao = await LanctoCartaoService.FilterBordero(relatorio)

                if (cartao.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(cartao.msg || "")
                    return false

                } else {

                    setLanctoCartaoEstorno(cartao.data.lanctoCartao)
                    setQtdLanctoCartao(cartao.data.qtd)
                    setTotLanctoCartao(cartao.data.total)
                    return true

                }
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar os lançamentos do cartão`)
            return false
        }

    }, [lanctoCartao, lanctoCartaoEstorno, datai, dataf, tipo, status, idBandeira, idVendedor, idCliente, bordero])

    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroLanctoCartao") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsLanctoCartao") as HTMLDivElement

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[1000px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[1000px]")) {

                menuInputs.classList.remove("invisible")

                const timer = setTimeout(() => {
                    clearTimeout(timer)
                }, 150)

            } else {

                menuInputs.classList.add("invisible")
            }

            event.currentTarget.blur()
        }
    }

    const handleLimparFiltros = () => {

        setDatai(dateI)
        setDataf(dateF)
        setStatus("A")
        setIdBandeira(0)
        setIdVendedor(0)
        setIdCliente(0)
        setBordero("")

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        searchBoxFocus()
    }

    const handleChangeDatai = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDataf = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const handleChangeTipo = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipo(e.target.value)
    }

    const handleChangeStatus = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setStatus(e.target.value)
    }

    const handleChangeBordero = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBordero(e.target.value.replace(/[^0-9]/g, ''))
    }

    //------------------------------------------------------------- BANDEIRA --------------------------------------------------------------------------------//
    const handleClearBandeiraSelecionada = useCallback(() => {

        setIdBandeira(0)
        setVisibleSearchBoxBandeira(false)

    }, [attributes?.bandeira])

    const handleFilterBandeiraClick = useCallback(async (description: string) => {

        if (description.trim() === "") {

            const newBandeiraList = [...attributes?.bandeira || []]
            setBandeiraList(newBandeiraList)

        } else {

            const newBandeiraList = [...attributes?.bandeira || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setBandeiraList(newBandeiraList || [])
        }

    }, [attributes?.bandeira])

    const handleBandeiraSelectClick = useCallback((v: Bandeira) => {

        if (v.id > 0) {
            setIdBandeira(v.id)
        } else {
            setIdBandeira(0)
        }

        const newBandeiraList = [...attributes?.bandeira || []]
        setBandeiraList(newBandeiraList)

        setVisibleSearchBoxBandeira(false)

    }, [attributes?.bandeira])

    const clickSearchBoxBandeira = useCallback(() => {
        setVisibleSearchBoxBandeira((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxVendedor(false)
                setVisibleSearchBoxCliente(false)
                inputFocusBandeira()
            }
            return newState
        })
    }, [])

    const inputFocusBandeira = () => {
        let inputSearch = document.getElementById(`inputSearchBox-bandeira`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------- VENDEDOR --------------------------------------------------------------------------------//
    const handleClearVendedorSelecionada = useCallback(() => {

        setIdVendedor(0)
        setVisibleSearchBoxVendedor(false)

    }, [attributes?.vendedor])

    const handleFilterVendedorClick = useCallback(async (description: string) => {

        if (description.trim() === "") {

            const newVendedorList = [...attributes?.vendedor || []]
            setVendedorList(newVendedorList)

        } else {

            const newVendedorList = [...attributes?.vendedor || []].filter((item) => {
                return item.description?.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setVendedorList(newVendedorList || [])
        }
    }, [attributes?.vendedor])

    const handleVendedorSelectClick = useCallback((v: Usuarios) => {

        if (v) {
            setIdVendedor(v.id)
        } else {
            setIdVendedor(0)
        }

        setVisibleSearchBoxVendedor(false)

    }, [attributes?.vendedor])

    const clickSearchBoxVendedor = useCallback(() => {
        setVisibleSearchBoxVendedor((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {

                setVisibleSearchBoxBandeira(false)
                setVisibleSearchBoxCliente(false)
                inputFocusVendedor()
            }
            return newState
        })
    }, [])

    const inputFocusVendedor = () => {
        let inputSearch = document.getElementById(`inputSearchBox-vendedor`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ----------------------------------------------------------- CLIENTE ------------------------------------------------------------
    const handleClearClienteSelecionada = useCallback(() => {

        setIdCliente(0)
        setVisibleSearchBoxCliente(false)

    }, [attributes?.cliente])

    const handleFilterClienteClick = useCallback(async (description: string) => {

        if (description.trim() === "") {


            const newClienteList = [...attributes?.cliente || []]
            setClienteList(newClienteList)

        } else {

            const newClienteList = [...attributes?.cliente || []].filter((item) => {
                return item.description?.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setClienteList(newClienteList || [])
        }
    }, [attributes?.cliente])

    const handleClienteSelectClick = useCallback((v: Clientes) => {

        if (v) {
            setIdCliente(v.id)
        } else {
            setIdCliente(0)
        }

        setVisibleSearchBoxCliente(false)

    }, [attributes?.cliente])

    const clickSearchBoxCliente = useCallback(() => {
        setVisibleSearchBoxCliente((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {

                setVisibleSearchBoxBandeira(false)
                setVisibleSearchBoxVendedor(false)
                inputFocusCliente()
            }
            return newState
        })
    }, [])

    const inputFocusCliente = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cliente`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //--------------------------------------------------------------------------------------------- FUNÇÕES GRID ------------------------------------------------------------------------------------------//
    const handleColumnLiqClick = useCallback(() => {


        let newLanctoCartaoList = [...lanctoCartao]
        newLanctoCartaoList = [...lanctoCartao]
        let total = 0

        for (let i in newLanctoCartaoList) {
            newLanctoCartaoList[i].selected = !selectDupAll
            total += newLanctoCartaoList[i].valor_receber || 0
        }

        if (selectDupAll) {
            setTotSelecionado(0)
        } else {
            setTotSelecionado(total)
        }

        setLanctoCartao(newLanctoCartaoList)
        setSelectDupAll(!selectDupAll)

    }, [lanctoCartao, selectDupAll])

    const handleCheckBoxClick = useCallback(async (id: number, selected: boolean) => {

        const newLanctoCartaoList = [...lanctoCartao]
        const index = newLanctoCartaoList.findIndex((item) => item.id === id)

        if (index >= 0) {

            newLanctoCartaoList[index].selected = !selected
            const itemSelecionado = newLanctoCartaoList[index]

            setLanctoCartao(newLanctoCartaoList)

            setTotSelecionado((prevTotal) => {
                let newTotal = prevTotal
                let valor = itemSelecionado.valor_receber || 0

                if (!selected) {
                    newTotal += valor
                } else {
                    newTotal -= valor
                }

                return parseFloat(newTotal.toFixed(2))
            })
        }

    }, [lanctoCartao])

    const handleCheckBoxEstornoClick = useCallback(async (id: number, selected: boolean) => {

        const newLanctoCartaoEstornoList = [...lanctoCartaoEstorno]
        const index = newLanctoCartaoEstornoList.findIndex((item) => item.id_bordero === id)

        if (index >= 0) {

            newLanctoCartaoEstornoList[index].selected = !selected
            const itemSelecionado = newLanctoCartaoEstornoList[index]

            setLanctoCartaoEstorno(newLanctoCartaoEstornoList)

            setTotSelecionado((prevTotal) => {
                let newTotal = prevTotal
                let valor = itemSelecionado.valor_receber || 0

                if (!selected) {
                    newTotal += valor
                } else {
                    newTotal -= valor
                }

                return parseFloat(newTotal.toFixed(2))
            })

            setQtdLanctoCartaoSelecionado((prevTotal) => {
                let newTotal = prevTotal

                if (!selected) {
                    newTotal += itemSelecionado.qtd // Se foi desmarcado, subtrai
                } else {
                    newTotal -= itemSelecionado.qtd // Se foi marcado, adiciona
                }

                return newTotal
            })
        }

    }, [lanctoCartaoEstorno])

    const handlerOpenModalLiqLanctoCartao = () => {
        setVisible(false)
        searchBoxFocus()

        let newLanctoCartaoList = [...lanctoCartao]
        newLanctoCartaoList = newLanctoCartaoList.filter((item) => item.selected === true)
        const newCtaSelectedList: number[] = []

        if (newLanctoCartaoList.length === 0) {

            const timer = setTimeout(() => {
                setMessage(`Nenhum lançamento selecionado`)
                setMessageType("DANGER")
                setVisible(true)
                clearTimeout(timer)
            }, 0)
            return
        }

        newLanctoCartaoList.map((item) => newCtaSelectedList.push(item.id))
        setLanctoCartaoSelectedList(newCtaSelectedList || [])

        setModalLiqLanctoCartaoVisible(true)
    }

    const handlerOpenModalEstornarLanctoCartao = async () => {

        setVisible(false)
        searchBoxFocus()

        let newLanctoCartaoEstornoList = [...lanctoCartaoEstorno]

        newLanctoCartaoEstornoList = newLanctoCartaoEstornoList.filter((item) => item.selected === true)
        const newCtaSelectedList: number[] = []
        const newBorderoList: number[] = []

        newLanctoCartaoEstornoList.map((item) => newCtaSelectedList.push(item.id_bordero))
        newLanctoCartaoEstornoList.map((item) => newBorderoList.push(item.id_bordero))
        setLanctoCartaoSelectedList(newCtaSelectedList || [])
        setBorderoSelectedList(newBorderoList)
        setModalEstornoLanctoCartaoVisible(true)
    }

    const fecharModalLiqLanctoCartao = useCallback(() => {
        setModalLiqLanctoCartaoVisible(false)
    }, [])

    const fecharModalEstornarLanctoCartao = useCallback(() => {
        setModalEstornoLanctoCartaoVisible(false)
    }, [])


    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-12 sm:col-span-10 xl:col-span-5 flex flex-row items-center`}>
                            <IoCreate className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Lançamento de Cartão</span>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-2 xl:col-span-1`}>
                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/lanctoCartao/excluidos'} data-tooltip-id={'tooltip-btn-lixeira'} id={'btn-lixeira'} className={`${classbtColunasVermelho} h-9`} >
                                <FaTrash size="25px" />
                            </Link>
                            <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-btn-lixeira'}
                                anchorSelect={'#btn-lixeira'} positionStrategy="fixed" place='left' >
                                <span>Lançamentos de Cartão Excluídos</span>
                            </Tooltip>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                            {status === "A" &&
                                <button tabIndex={-1} className={` ${classBt} ${classbtAzul} w-full disabled:opacity-50 disabled:cursor-not-allowed h-9`} disabled={totSelecionado > 0 ? false : true} onClick={handlerOpenModalLiqLanctoCartao}>
                                    <span >Baixar lançamentos</span>
                                </button>
                            }

                            {status === "B" &&
                                <button tabIndex={-1} className={`${classBt} ${classbtVermelho} w-full disabled:opacity-50 disabled:cursor-not-allowed h-9`} disabled={totSelecionado > 0 ? false : true} onClick={handlerOpenModalEstornarLanctoCartao}>
                                    <span className='mx-1'>Estornar lançamentos</span>
                                </button>
                            }
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>

                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/lanctoCartao/new'} className={`${classBtSemDuration} ${classbtVerde} h-9`} >
                                <IoAddCircleSharp className={`mx-2 hidden md:block`} size="20px" /> Cadastro
                            </Link>

                        </div>

                    </div>

                    <div id='divInputsLanctoCartao' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroLanctoCartao' className={`relative max-h-[0px] h-[790px] sm:h-[390px] md:h-[410px] lg:h-[340px] xl:h-[290px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-4 px-3`}>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id='data_inicial_lanctoCartao' className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' autoComplete='off' value={datai} disabled={loading} onFocus={searchBoxFocus} onChange={handleChangeDatai} />
                                <label htmlFor="data_inicial_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{status === 'B' ? 'Data da Baixa Inicial' : tipo === 'dt_vencimento' ? 'Data de Vencimento Inicial' : 'Data de Chegada Inicial'}</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id='data_final_lanctoCartao' className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' autoComplete='off' value={dataf} disabled={loading} onFocus={searchBoxFocus} onChange={handleChangeDataf} />
                                <label htmlFor="data_final_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{status === 'B' ? 'Data da Baixa Final' : tipo === 'dt_vencimento' ? 'Data de Vencimento Final' : 'Data de Chegada Final'}</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <select id="relatorio_lanctoCartao" className={`${classInput} ${classInputDark} `} value={tipo} onFocus={searchBoxFocus} onChange={handleChangeTipo}>
                                    {status === "A" ? (
                                        <>
                                            <option value="dt_vencimento" className="text-slate-900 dark:text-slate-200">Por vencimento</option>
                                            <option value="dt_chegada" className="text-slate-900 dark:text-slate-200">Por data de chegada</option>
                                        </>
                                    ) : (
                                        <>
                                            <option value="dt_baixa" className="text-slate-900 dark:text-slate-200">Por data da baixa</option>
                                        </>
                                    )
                                    }

                                </select>
                                <label htmlFor="relatorio_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Relatório</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <select id="status_lanctoCartao" className={`${classInput} ${classInputDark} ${status === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} value={status} onFocus={searchBoxFocus} onChange={handleChangeStatus}>
                                    <option value="A" className={`text-slate-900 dark:text-slate-200`}>Abertos</option>
                                    <option value="B" className={`text-slate-900 dark:text-slate-200`}>Baixados</option>
                                </select>
                                <label htmlFor="status_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Status</label>
                            </div>

                            <div id='componenteBandeira' className={`relative col-span-12 sm:col-span-8 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <SearchBox
                                    dataList={bandeiraList}
                                    idRegistro={idBandeira || undefined}
                                    label='Bandeira'
                                    componentId='bandeira'
                                    visibleTAB={visibleSearchBoxBandeira}
                                    clearDataClick={handleClearBandeiraSelecionada}
                                    setDataClick={handleBandeiraSelectClick}
                                    filterDataClick={handleFilterBandeiraClick}
                                    clicado={clickSearchBoxBandeira}
                                />
                            </div>

                            <div id='componenteVendedor' className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <SearchBox
                                    dataList={vendedorList}
                                    idRegistro={idVendedor || undefined}
                                    label='Vendedor'
                                    componentId='vendedor'
                                    visibleTAB={visibleSearchBoxVendedor}
                                    clearDataClick={handleClearVendedorSelecionada}
                                    setDataClick={handleVendedorSelectClick}
                                    filterDataClick={handleFilterVendedorClick}
                                    clicado={clickSearchBoxVendedor}
                                />
                            </div>

                            <div id='componenteCliente' className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <SearchBox
                                    dataList={clienteList}
                                    idRegistro={idCliente || undefined}
                                    label='Cliente'
                                    componentId='cliente'
                                    visibleTAB={visibleSearchBoxCliente}
                                    clearDataClick={handleClearClienteSelecionada}
                                    setDataClick={handleClienteSelectClick}
                                    filterDataClick={handleFilterClienteClick}
                                    clicado={clickSearchBoxCliente}
                                />
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id="bordero_lanctoCartao" className={`${classInput} ${classInputDark} `} type='text' inputMode="numeric" placeholder=' ' autoComplete='off' value={bordero} disabled={loading || status === "A"} onFocus={searchBoxFocus} onChange={handleChangeBordero} />
                                <label htmlFor="bordero_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Borderô</label>
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>

                                    <button disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>

                            </div>

                            <div className={`col-span-12`}>

                                <div className={`flex flex-col lg:flex-row md:py-2 justify-start w-full h-auto border border-slate-500 rounded-md bg-gray-200 dark:bg-slate-700`}>

                                    <div className={`w-full lg:w-[25%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row border lg:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                        <span className={`w-full lg:w-auto`}>N° de Lançamentos: </span>
                                        <span className={`w-full lg:w-auto flex justify-end items-center lg:ml-2`}>{qtdLanctoCartao}</span>
                                    </div>

                                    <div className={`w-full lg:w-[35%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row border lg:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                        <span className={`w-full lg:w-auto`}>Total: </span>
                                        <span className={`w-full lg:w-auto flex justify-end items-center lg:ml-2`}>{Funcoes.numberFormat(totLanctoCartao, 'currency')}</span>
                                    </div>

                                    <div className={`w-full lg:w-[40%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row `}>
                                        <span className={`w-full lg:w-auto`}>Total Selecionado: </span>
                                        <span className={`w-full lg:w-auto flex justify-end items-center lg:ml-2`}>{Funcoes.numberFormat(totSelecionado, 'currency')}</span>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 bg-white dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>

                        {status === 'A' &&

                            <GridLanctoCartao
                                lanctoCartao={lanctoCartao}
                                tipo={"A"} // status === "B" ? "B" : "A"
                                selectedAll={selectDupAll}
                                handleColumnLiqClick={handleColumnLiqClick}
                                handleSelectItemClick={handleCheckBoxClick}
                                handleUpdateLanctoCartaoList={filterDados}
                                id_select={idSelect}
                            />

                        }

                        {status === 'B' &&

                            <GridLanctoCartaoEstorno
                                lanctoCartaoEstorno={lanctoCartaoEstorno}
                                handleSelectItemClick={handleCheckBoxEstornoClick}

                            />
                        }

                    </div>

                </div>

                <ModalLiqLancamentoCartao
                    visible={modalLiqLanctoCartaoVisible}
                    totSelecionado={totSelecionado}
                    lanctoCartaoSelectedList={lanctoCartaoSelectedList}
                    handleModalClose={fecharModalLiqLanctoCartao}
                    handleConfirm={filterDados}
                />

                <ModalEstLancamentoCartao
                    visible={modalCancelLiqVisible}
                    totSelecionado={totSelecionado}
                    qtdLanctoCartaoSelecionado={qtdLanctoCartaoSelecionado}
                    lanctoCartaoSelectedList={lanctoCartaoSelectedList}
                    bordero={borderoSelectedList}
                    handleModalClose={fecharModalEstornarLanctoCartao}
                    handleConfirm={filterDados}
                />

            </div>

        </Template>
    )

}